import React from 'react';

import { SatRadio } from '@components/common/satUI';

/**
 * 계약이전고지화면표시방법코드 (B2)
 * 문구전 라디오버튼
 * @param {*} props
 * @returns
 */
const RadioButtonBeforeAns = props => {
  const {
    isPreUw = false,
    group,
    items,
    tbNbsPolicyBfNtceAnsDtlDTO,
    tbNbsPolicyBfNtceAnsByitmDtlDTO,
    setTbNbsPolicyBfNtceAnsByitmDtlDTO,
    onSave,
  } = props;

  const onChange = option => {
    const { value } = option;

    // 질문 그룹에 해당하는 라디오 답변 목록
    const prevItem = tbNbsPolicyBfNtceAnsByitmDtlDTO.find(
      dtl =>
        dtl.policyBfNtceItmGrpNo === group.policyBfNtceItmGrpNo &&
        items.find(itm => itm.policyBfNtceItmNo === dtl.policyBfNtceItmNo),
    );

    let newTbNbsPolicyBfNtceAnsByitmDtlDTO;
    if ($utils.isEmptyObject(prevItem)) {
      newTbNbsPolicyBfNtceAnsByitmDtlDTO = [
        ...tbNbsPolicyBfNtceAnsByitmDtlDTO,
        {
          ansContn: '1',
          ansDataTyTpCd: '2',
          policyBfNtceId: '',
          policyBfNtceItmGrpNo: group.policyBfNtceItmGrpNo,
          policyBfNtceItmNo: value,
        },
      ];
    } else {
      newTbNbsPolicyBfNtceAnsByitmDtlDTO = tbNbsPolicyBfNtceAnsByitmDtlDTO.map(
        dtl => {
          if (
            dtl.policyBfNtceItmGrpNo === group.policyBfNtceItmGrpNo &&
            dtl.policyBfNtceItmNo === prevItem.policyBfNtceItmNo
          ) {
            return {
              ...dtl,
              policyBfNtceItmNo: value,
            };
          }
          return dtl;
        },
      );
    }

    setTbNbsPolicyBfNtceAnsByitmDtlDTO(newTbNbsPolicyBfNtceAnsByitmDtlDTO);
    onSave(
      value,
      { group, item: items.find(item => item.policyBfNtceItmNo === value) },
      {
        tbNbsPolicyBfNtceAnsDtlDTO,
        tbNbsPolicyBfNtceAnsByitmDtlDTO: newTbNbsPolicyBfNtceAnsByitmDtlDTO,
      },
    );
  };

  return (
    <div className={'check-box renew divide-4'}>
      <SatRadio
        disabled={isPreUw}
        name={`radio_${group.policyBfNtceItmGrpNo}`}
        options={items.map(item => ({
          label: item.itmDispContn,
          value: item.policyBfNtceItmNo,
        }))}
        onChange={onChange}
        value={
          tbNbsPolicyBfNtceAnsByitmDtlDTO.find(
            dtl =>
              dtl.policyBfNtceItmGrpNo === group.policyBfNtceItmGrpNo &&
              items.find(
                itm => itm.policyBfNtceItmNo === dtl.policyBfNtceItmNo,
              ),
          )?.policyBfNtceItmNo
        }
      />
    </div>
  );
};

export default RadioButtonBeforeAns;
